import { useMemo } from 'react';
import type { FeatureFlagKey } from '../constants';
import { useFeatureFlagQuery } from '../system.service';

export function useFeatureFlag(featureFlag: FeatureFlagKey) {
  const { data: featureFlagList } = useFeatureFlagQuery();

  return useMemo(() => !!featureFlagList?.[featureFlag], [featureFlagList, featureFlag]);
}
